// endpoints for life insurance import flow (upload, validation, list invalids, corrections, finish)
export const importFileEndpoints = (builder) => ({
  // Upload excel file (FormData)
  uploadExcel: builder.mutation({
    query: (formData) => ({
      url: '/import-file/upload/excel-bulk',
      method: 'POST',
      // when body is FormData, do not set Content-Type so browser sets boundary
      body: formData,
    }),
    invalidatesTags: ['ImportFile'],
  }),

  // Validations (imperative mutations so component can call after upload)
  validateInsurers: builder.mutation({
    query: (batchId) => ({ url: `/import-file/validate/insurers/${batchId}`, method: 'GET' }),
  }),
  validateAgencies: builder.mutation({
    query: (batchId) => ({ url: `/import-file/validate/agencies/${batchId}`, method: 'GET' }),
  }),
  validateProducts: builder.mutation({
    query: (batchId) => ({ url: `/import-file/validate/products/${batchId}`, method: 'GET' }),
  }),
  validateFup: builder.mutation({
    query: (batchId) => ({ url: `/import-file/validate/fup/${batchId}`, method: 'GET' }),
  }),
  validateCustomers: builder.mutation({
    query: (batchId) => ({ url: `/import-file/validate/customers/${batchId}`, method: 'GET' }),
  }),

  // Lists of invalid distinct items (for modal)
  getInvalidInsurers: builder.mutation({
    query: (batchId) => ({ url: `/import-file/invalid-insurers/${batchId}`, method: 'GET' }),
  }),
  getInvalidProducts: builder.mutation({
    query: (batchId) => ({ url: `/import-file/invalid-products/${batchId}`, method: 'GET' }),
  }),
  getInvalidAgencies: builder.mutation({
    query: (batchId) => ({ url: `/import-file/invalid-agencies/${batchId}`, method: 'GET' }),
  }),
  getInvalidCustomers: builder.mutation({
    query: (batchId) => ({ url: `/import-file/invalid-customers/${batchId}`, method: 'GET' }),
  }),
  getInvalidFup: builder.mutation({
    query: (batchId) => ({ url: `/import-file/invalid-fup/${batchId}`, method: 'GET' }),
  }),

  // Apply a single correction (map/create)
  applyCorrection: builder.mutation({
    query: (body) => ({ url: '/import-file/apply-correction', method: 'POST', body }),
    invalidatesTags: ['ImportFile'],
  }),

  // Finish import
  finishImport: builder.mutation({
    query: (body) => ({ url: '/import-file/finish-import', method: 'POST', body }),
    invalidatesTags: ['ImportFile'],
  }),

  // List batches maintained on backend
  getBatches: builder.query({
    query: ({ limit } = { limit: 100 }) => ({ url: `/import-file/batches?limit=${limit}`, method: 'GET' }),
    providesTags: ['ImportFile'],
  }),

  // Bulk insertion (call backend bulk customer corrections endpoint)
  bulkCreateCustomers: builder.mutation({
    query: (body) => ({
      url: '/import-file/customers/bulk',
      method: 'POST',
      body,
    }),
    invalidatesTags: ['ImportFile'],
  }),

//Check existing groups
  checkExistingGroups: builder.mutation({
  query: (body) => ({
    url: "/import-file/check-existing-groups",
    method: "POST",
    body,
  }),
}),

  // Fetch products filtered by a specific insurer (backend-enforced — never frontend-only filtering)
  getProductsByInsurer: builder.query({
    query: (insurerId) => ({ url: `/import-file/products-by-insurer?insurerId=${insurerId}`, method: 'GET' }),
  }),

  // Fetch per-batch import summary (total, success, duplicates, invalids)
  getImportSummary: builder.query({
    query: (batchId) => ({ url: `/import-file/import-summary/${batchId}`, method: 'GET' }),
  }),

  // Fetch duplicate policy numbers for a batch
  getDuplicatePolicies: builder.mutation({
    query: (batchId) => ({ url: `/import-file/duplicate-policies/${batchId}`, method: 'GET' }),
  }),

  // Fetch import status for background job polling
  getImportStatus: builder.query({
    query: (batchId) => ({ url: `/import-file/import-status/${batchId}`, method: 'GET' }),
  }),

});
